import { render } from "./Authenticated.vue?vue&type=template&id=01c4dacd"
import script from "./Authenticated.vue?vue&type=script&lang=js"
export * from "./Authenticated.vue?vue&type=script&lang=js"

import "./Authenticated.vue?vue&type=style&index=0&id=01c4dacd&lang=css"

import exportComponent from "/home/stagingfloretcollegein/staging.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__